import { render, staticRenderFns } from "./TgFormTable.vue?vue&type=template&id=30ebd637"
import script from "./TgFormTable.vue?vue&type=script&lang=js"
export * from "./TgFormTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports